import { cloneDeep, forEach, isEqual } from 'lodash-es'
import i18n from '@/locales/'
import cardsApi from '../_api'
import { segmentTrack } from '@/analytics/segment'
export default {
  fetchCards: async ({ commit, dispatch, getters }) => {
    if (getters.isCallingCards) return
    try {
      commit('setIsCallingCards', true)
      const page = getters.currentPage
      const filters = getters.filters
      const response = await cardsApi.getCards(page, filters)
      commit('setCards', response.data)
      commit('setCardsLastPage', response.headers['pagination-last-page'])
      commit(
        'setCardsTotalItems',
        Number.parseInt(response.headers['pagination-total-items'])
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'cards_action_fetch_cards_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCards', false)
    }
  },

  activateCard: async (
    { commit, dispatch, getters },
    { cardId, passcode, cardInfo }
  ) => {
    if (getters.isCallingCards) return
    try {
      commit('setIsCallingCards', true)
      const response = await cardsApi.putActivateCard(cardId, passcode)
      commit('updateCard', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('cards_action_activate_card_success'),
        { root: true }
      )
      segmentTrack('User member card unfrozen', {
        member_card_count: getters.totalItems,
        member_card_id: cardId,
        member_card_name: cardInfo.alias
      })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'cards_action_activate_card_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCards', false)
    }
  },
  sortCardsByField: (
    { dispatch, getters, commit },
    { fieldName, direction = 'TOGGLE' }
  ) => {
    const fields = Array.isArray(fieldName) ? fieldName : [fieldName]
    let newFilters = {}
    fields.forEach(el => {
      const order = `order[${el}]`
      if (direction === 'TOGGLE') {
        if (getters.filters[order] === 'ASC') {
          newFilters[order] = 'DESC'
        } else if (getters.filters[order] === 'DESC') {
          newFilters[order] = undefined
        } else {
          newFilters[order] = 'ASC'
        }
      }
    })
    Object.keys(getters.filters).forEach(item => {
      if (item.includes('order') && !item.includes(fieldName)) {
        getters.filters[item] = undefined
      }
    })
    dispatch('addCardsFilters', newFilters)
  },

  freezeCard: async (
    { commit, dispatch, getters },
    { cardId, passcode, cardInfo }
  ) => {
    if (getters.isCallingCards) return
    try {
      commit('setIsCallingCards', true)
      const response = await cardsApi.putFreezeCard(cardId, passcode)
      commit('updateCard', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('cards_action_freeze_card_success'),
        { root: true }
      )
      segmentTrack('User member card frozen', {
        member_card_count: getters.totalItems,
        member_card_id: cardId,
        member_card_name: cardInfo.alias
      })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'cards_action_freeze_card_error' }, { root: true })
      throw error
    } finally {
      commit('setIsCallingCards', false)
    }
  },

  setCardsFilters: async ({ commit, getters, dispatch }, filters) => {
    // by default sort id desc.
    filters['order[id]'] = 'DESC'
    if (!isEqual(filters, getters.filters)) {
      commit('setCardsFilters', filters)
      await dispatch('fetchCards')
    }
  },
  addCardsFilters: ({ dispatch, getters }, newFilters) => {
    var currentFilters = cloneDeep(getters.filters)
    forEach(currentFilters, (e, k) => {
      const parts = k.split('[')
      if (parts.length === 1) return
      var searchedKey = parts[0]
      forEach(newFilters, (f, l) => {
        if (l.includes(searchedKey)) {
          delete currentFilters[k]
        }
      })
    })
    let mergeFilters = { ...currentFilters, ...newFilters }
    mergeFilters = forEach(mergeFilters, (e, k) => {
      if (e == null) {
        delete mergeFilters[k]
      }
    })
    dispatch('setCardsFilters', mergeFilters)
  },

  nextCardsPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingCards) return

    commit('incrementCardsCurrentPage')
    dispatch('fetchCards')
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
